<template>
  <IQOS :title="$t('mode_settings.schedule')" enabled required>
    <ScheduleEdit :invalid="invalid" :editing="editing" v-model="schedule" />

    <template #actions>
      <IQOSActions
        :editing="editing"
        @edit="showEditUI"
        @accept="onEditFinish"
      />
    </template>
  </IQOS>
</template>

<script>
import ScheduleEdit from "@/components/schedule/ScheduleEdit.vue";

function getEmptyDay() {
  return {
    workday: false,
    startHour: null,
    endHour: null,
    startMinute: null,
    endMinute: null,
  };
}

export default {
  data() {
    return {
      emptySchedule: {
        mon: getEmptyDay(),
        tue: getEmptyDay(),
        wed: getEmptyDay(),
        thu: getEmptyDay(),
        fri: getEmptyDay(),
        sat: getEmptyDay(),
        sun: getEmptyDay(),
      },
      editing: false,
      invalid: false,
    };
  },
  components: {
    ScheduleEdit,
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    onEditFinish() {
      this.invalid = false;

      const is_schedule_invalid = !!Object.values(this.schedule).find((day) => {
        return (
          day.workday &&
          (day.startHour === null ||
          day.endHour === null ||
          day.startMinute === null ||
          day.endMinute === null)
        );
      });

      if (is_schedule_invalid) {
        this.invalid = true;
        return;
      }

      this.editing = false;

      this.$store.dispatch("saveCafe");

      this.$store.dispatch("auditlog/write", {
        type: "cafe_schedule",
        payload: {
          mode: "general",
          schedule: {
            ...this.schedule,
            enabled: true
          },
        },
      });
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    schedule: {
      get() {
        if (!this.cafe.schedule || !this.cafe.schedule.mon) {
          return this.emptySchedule;
        }

        return this.cafe.schedule;
      },
      set(v) {
        this.$store.commit("patchCafeGeneralData", {
          schedule: v,
        });
      },
    },
  },
};
</script>

<style>
</style>
